import http from '../api/http';

function downloadFile(blob, name) {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function downloadFileFromAPI(url, name) {
  http({
    url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    downloadFile(response.data, name);
  });
}

export { downloadFile, downloadFileFromAPI };
